export default "__VITE_ASSET__DYUBsh4S__"